export default class Accordion {
    constructor() {
        this.accordionContent = document.querySelectorAll('.fd-accordion-content');
        this.accordionTitle = document.querySelectorAll('.fd-accordion-title');
        this.accordion = document.querySelectorAll('.fd-accordion');

        this.init();
    }

    init () {
        this.accordion.forEach( (item, index) => {
            const accordionChild = item.querySelectorAll('.fd-accordion-title');

            if (accordionChild.length === 1) {
                item.classList.add('single-item');
            }
            item.querySelector('.fd-accordion-title').classList.add('item-active');
            item.querySelector('.fd-accordion-content').classList.add('content-active');
        });

        this.accordionTitle.forEach( (item, index) => {
            item.addEventListener( 'click', (e) => {
                const accordionParent = item.closest('.fd-accordion');
                // console.log(item, 'click');

                if (!accordionParent.classList.contains('single-item')) {
                    if(!item.classList.contains('item-active')) {
                        let itemActive = accordionParent.querySelector('.item-active');

                        if (itemActive) {
                            accordionParent.querySelector('.item-active').classList.remove('item-active');
                            accordionParent.querySelector('.content-active').classList.remove('content-active');
                        }

                        item.classList.add('item-active');
                        item.nextElementSibling.classList.add('content-active');
                    } else {
                        accordionParent.querySelector('.item-active').classList.remove('item-active');
                        accordionParent.querySelector('.content-active').classList.remove('content-active');
                    }
                }

                return false;
            })
        });
    }
}